export default {
  separator: {
    marginLeft: 4,
    marginRight: 4,
  },
}
